<p-messages key="card-form-message" />
<form [formGroup]="newPaymentMethodFormGroup" autocomplete="off">
    <div class="field col flex flex-wrap gap-3" *ngIf="echeckPaymentEnabled">
        <div *ngFor="let paymentMethodType of paymentMethodTypes" class="field-checkbox">
            <p-radioButton
            [inputId]="paymentMethodType.name"
            [value]="paymentMethodType.value"
            formControlName="payment_method_type"
            (onClick)="paymentMethodChanged($event)" />
            <label [for]="paymentMethodType.name" class="ml-2">
                {{ paymentMethodType.name }}
            </label>
        </div>
    </div>
    <div class="field col p-0">
        <input pInputText id="name" formControlName="name" class="w-full" placeholder="Name" />
        <small>e.g. Business card, Personal Check...</small>
        <div *ngIf="savePaymentMethodFormSubmitted && newPaymentMethodFormGroup.controls['name'].errors">
            <div class="ui-messages-error"
                *ngIf="newPaymentMethodFormGroup.controls['name'].errors?.['required']">
                Please payment method name.
            </div>
        </div>
    </div>
    <div *ngIf="newPaymentMethodFormGroup.value['payment_method_type'] == 'eCheck'">
        <div class="field col p-0">
            <input pInputText id="account_owner_name" formControlName="account_owner_name" class="w-full" placeholder="Account Owner Name" />
            <small>The name on the account.</small>
            <div *ngIf="savePaymentMethodFormSubmitted && newPaymentMethodFormGroup.controls['account_owner_name'].errors">
                <div class="ui-messages-error"
                    *ngIf="newPaymentMethodFormGroup.controls['account_owner_name'].errors?.['required']">
                    Please enter account name.
                </div>
            </div>
        </div>
        <div class="field col p-0">
            <input pInputText id="routing_number" formControlName="routing_number" class="w-full" placeholder="Routing Number" />
            <div *ngIf="savePaymentMethodFormSubmitted && newPaymentMethodFormGroup.controls['routing_number'].errors">
                <div class="ui-messages-error"
                    *ngIf="newPaymentMethodFormGroup.controls['routing_number'].errors?.['required']">
                    Please enter routing number.
                </div>
                <div class="ui-messages-error"
                    *ngIf="newPaymentMethodFormGroup.controls['routing_number'].errors?.['pattern']">
                    Please routing number should contain 9 digits only.
                </div>
            </div>
        </div>
        <div class="field col p-0">
            <input pInputText id="account_number" formControlName="account_number" class="w-full" placeholder="Bank Account Number" />
            <div
                    *ngIf="savePaymentMethodFormSubmitted && newPaymentMethodFormGroup.controls['account_number'].errors">

                    <div class="ui-messages-error"
                        *ngIf="newPaymentMethodFormGroup.controls['account_number'].errors?.['required']">
                        Please enter account number.
                    </div>
                    <div class="ui-messages-error"
                        *ngIf="newPaymentMethodFormGroup.controls['account_number'].errors?.['pattern']">
                        Please account number should have digits only.
                    </div>
                    <div class="ui-messages-error"
                        *ngIf="newPaymentMethodFormGroup.controls['account_number'].errors?.['requiredLength']">
                        Please account number should have maximum {{ newPaymentMethodFormGroup.controls['account_number'].errors['requiredLength'] }} digits only.
                    </div>
                </div>
        </div>
        <div class="field col flex flex-wrap gap-3">
            <div *ngFor="let accountType of accountTypes" class="field-checkbox">
                <p-radioButton
                [inputId]="accountType.name"
                [value]="accountType.value"
                formControlName="account_type"/>
                <label [for]="accountType.name" class="ml-2">
                    {{ accountType.name }}
                </label>
            </div>
        </div>
    </div>
</form>
<div id="trigger-card-payment" style="height: 200px;" *ngIf="newPaymentMethodFormGroup.value['payment_method_type'] == 'Credit Card'"></div>